import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { GlobalStyle } from './styles/GlobalStyle';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import QuizPage from './pages/QuizPage';
import ExploreMore from './pages/ExploreMore';

function AppContent() {
  const location = useLocation();
  const hideNavigation = location.pathname === '/explore-more';

  return (
    <div className="App">
      {!hideNavigation && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/explore-more" element={<ExploreMore />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </main>
      {!hideNavigation && <Footer />}
    </div>
  );
}

const App: React.FC = () => {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <AppContent />
    </Router>
  );
};

export default App;